export default __webpack_public_path__ + "static/joalis-9f905ff0162557b129e0f9b51b0a38c0.png";